(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('WarningDialogController', WarningDialogController);

    WarningDialogController.$inject = ['$timeout', '$filter', '$scope', '$stateParams', 'entity', 'Warning', 'WarningCategory', 'TabObjectTypes', 'TabFleets', 'UserProfile', '$state', 'ParseLinks', 'AlertService', 'TabActions', 'Macro', '$uibModal', '$http', 'CommandManifest'];

    function WarningDialogController($timeout, $filter, $scope, $stateParams, entity, Warning, WarningCategory, TabObjectTypes, TabFleets, UserProfile, $state, ParseLinks, AlertService, TabActions, Macro, $uibModal, $http, CommandManifest) {
        var vm = this;
        vm.warning = entity;
        vm.tabFleets = [];
        vm.macro = [];
        vm.fleetPage = 0;
        vm.fleetLinks = {};
        vm.tabObjectTypes = [];
        vm.objectTypePage = 0;
        vm.objectTypeLinks = {};
        vm.userProfiles = [];
        vm.userProfilePage = 0;
        vm.userProfileLinks = {};
        vm.warningCategories = [];
        vm.warningCategoryPage = 0;
        vm.warningCategoryLinks = {};
        vm.commandKeys = ["actionId", "command", "deviceReleases", "form", "schema", "weight"];
        vm.fleetsTosave = [];
        vm.metric = [];
        vm.operator = [];
        vm.addMetric = [];
        vm.tempMetric = null;
        vm.quantity = 1;
        vm.expected = [];
        vm.expectedNumber = [];
        vm.checkType = [];
        vm.expectedA = [];
        vm.expectedB = [];
        vm.expectedDate = [];
        vm.expectedDateA = [];
        vm.expectedDateB = [];
        vm.metricDate = [];
        vm.metricDateDown = [];
        vm.datepickerOptions = {
            minDate: new Date()
        };
        vm.formDate = [];
        vm.typeDateForm = [];
        vm.relativeDateNumber = [];
        vm.relativeDate = [];
        vm.relativeDateSimbol = [];
        vm.relativeDateNumberB = [];
        vm.relativeDateB = [];
        vm.relativeDateSimbolB = [];
        vm.lastQuery = "";
        vm.compose = true;
        vm.isGreengrassObjectType = false;
        vm.commandList = [];
        vm.objectTypeCache = {};
        vm.GREENGRASS_COMMAND_KEY = "__greengrassCommand";
        vm.GREENGRASS_TARGET_KEY = "__greengrassTarget";

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        var onSaveSuccess = function (result) {
            if (vm.fleetsTosave.length > 0) {
                vm.saveByFleet();
            } else {
                $scope.$emit('jotApp:warningUpdate', result);
                vm.isSaving = false;
                $state.go('warning');
            }
        };

        var onSaveError = function () {
            vm.isSaving = false;
        };

        function getDate(date){
            var formatDate = $filter('date')(date, "yyyy-MM-dd HH:mm");
            var d = formatDate.toString().split(" ");
            return d[0]+"T"+d[1];
        }

        function createQuery(){
            console.log("Inizio costruzione query. Metriche selezionate:", vm.tempMetric);
            if(vm.compose){
                var error = "";
                var query = [];
                for(var i = 0; i < Object.keys(vm.tempMetric).length; i++){
                    var app = {};
                    var errorField = true;
                    var errorDate = true;
                    app.metric = vm.tempMetric[i].name;
                    if(vm.checkType[i] != null){
                        app.type = vm.checkType[i];
                        switch (app.type) {
                            case "Exists":
                            case "Not Exists":
                                if(vm.operator[i] != null){
                                    app.operator = vm.operator[i].name;
                                }
                                query.push(app);
                                errorDate = false;
                                errorField = false;
                                break;
                            case "Equals":
                            case "Not Equals":
                                if(vm.expected[i] != null && vm.expected[i].length > 0){
                                    if(vm.operator[i] != null){
                                        app.operator = vm.operator[i].name;
                                    }
                                    app.value = vm.expected[i];
                                    query.push(app);
                                    errorField = false;
                                }
                                if(vm.expectedNumber[i] != null){
                                    if(vm.operator[i] != null){
                                        app.operator = vm.operator[i].name;
                                    }
                                    app.value = vm.expectedNumber[i];
                                    query.push(app);
                                    errorField = false;
                                }
                                if(vm.expectedDate[i] != null){
                                    if(vm.operator[i] != null){
                                        app.operator = vm.operator[i].name;
                                    }
                                    app.value = getDate(vm.expectedDate[i]);
                                    app.date = true;
                                    query.push(app);
                                    errorField = false;
                                }
                                errorDate = false;
                                break;
                            case "Lower":
                            case "Lower equals":
                            case "Greater":
                            case "Greater equals":
                                if (vm.tempMetric[i].type !== "date") {
                                    if (vm.expectedNumber[i] != null) {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = "" + vm.expectedNumber[i];
                                        app.date = false;
                                        query.push(app);
                                        errorField = false;
                                    }
                                } else {
                                    if (vm.expectedDate[i] != null && vm.typeDateForm[i] === "absolute") {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = getDate(vm.expectedDate[i]);
                                        app.date = true;
                                        query.push(app);
                                        errorField = false;
                                    } else {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = vm.expected[i] == null ? "now" : vm.expected[i];
                                        app.date = true;
                                        query.push(app);
                                        errorField = false;
                                    }
                                }
                                errorDate = false;
                                break;
                            case "Between":
                                if (vm.tempMetric[i].type !== "date") {
                                    if (vm.expectedA[i] != null && vm.expectedB[i] != null) {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = "" + vm.expectedA[i];
                                        app.valueB = "" + vm.expectedB[i];
                                        app.date = false;
                                        query.push(app);
                                        errorField = false;
                                    }
                                    errorDate = false;
                                } else {
                                    if (vm.typeDateForm[i] === "absolute") {
                                        if (vm.expectedDateA[i] != null && vm.expectedDateB[i] != null) {
                                            if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                            if (vm.expectedDateA[i] > vm.expectedDateB[i]) {
                                                errorDate = true;
                                            } else {
                                                app.value = getDate(vm.expectedDateA[i]);
                                                app.valueB = getDate(vm.expectedDateB[i]);
                                                app.date = true;
                                                query.push(app);
                                                errorField = false;
                                            }
                                        } else {
                                            errorDate = false;
                                        }
                                    } else {
                                        if (vm.operator[i] != null) app.operator = vm.operator[i].name;
                                        app.value = vm.expected[i] == null ? "now" : vm.expected[i];
                                        app.valueB = vm.expectedB[i] == null ? "now" : vm.expectedB[i];
                                        app.date = true;
                                        query.push(app);
                                        errorField = false;
                                    }
                                }
                                break;
                        }
                    } else {
                        error = "Field cannot be empty";
                        break;
                    }
                    if (errorField) {
                        error = errorDate ? "Error set date in metric" : "Field cannot be empty";
                        break;
                    }
                }
                if (error === "") {
                    vm.warning.query = "";
                    for (var i = 0; i < Object.keys(query).length; i++) {
                        switch (query[i].type) {
                            case "Exists":
                                vm.warning.query += "_exists_:" + query[i].metric;
                                break;
                            case "Not Exists":
                                vm.warning.query += "!_exists_:" + query[i].metric;
                                break;
                            case "Equals":
                                if (!query[i].date) {
                                    vm.warning.query += /^-?[\d.]+(?:e-?\d+)?$/.test(query[i].value) ?
                                        query[i].metric + ":" + query[i].value :
                                        query[i].metric + ":\"" + query[i].value + "\"";
                                } else {
                                    vm.warning.query += query[i].metric + ":\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"";
                                }
                                break;
                            case "Not Equals":
                                if (!query[i].date) {
                                    vm.warning.query += /^-?[\d.]+(?:e-?\d+)?$/.test(query[i].value) ?
                                        "!" + query[i].metric.replace(/\s/g, '') + ":" + query[i].value :
                                        "!" + query[i].metric.replace(/\s/g, '') + ":\"" + query[i].value + "\"";
                                } else {
                                    vm.warning.query += "!" + query[i].metric.replace(/\s/g, '') + ":\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"";
                                }
                                break;
                            case "Lower":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":<\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"" :
                                        query[i].metric + ":<" + query[i].value;
                                } else {
                                    vm.warning.query += query[i].metric + ":<" + query[i].value;
                                }
                                break;
                            case "Lower equals":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":<=\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"" :
                                        query[i].metric + ":<=" + query[i].value;
                                } else {
                                    vm.warning.query += query[i].metric + ":<=" + query[i].value;
                                }
                                break;
                            case "Greater":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":>\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"" :
                                        query[i].metric + ":>" + query[i].value;
                                } else {
                                    vm.warning.query += query[i].metric + ":>" + query[i].value;
                                }
                                break;
                            case "Greater equals":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":>=\"" + query[i].value.substring(0, query[i].value.length - 6) + "\"" :
                                        query[i].metric + ":>=" + query[i].value;
                                } else {
                                    vm.warning.query += query[i].metric + ":>=" + query[i].value;
                                }
                                break;
                            case "Between":
                                if (query[i].date) {
                                    vm.warning.query += vm.typeDateForm[i] === "absolute" ?
                                        query[i].metric + ":[\"" + query[i].value.substring(0, query[i].value.length - 6) + " TO " + query[i].valueB.substring(0, query[i].valueB.length - 6) + "\"]" :
                                        query[i].metric + ":[" + query[i].value + " TO " + query[i].valueB + "]";
                                } else {
                                    vm.warning.query += query[i].metric + ":[" + query[i].value + " TO " + query[i].valueB + "]";
                                }
                                break;
                        }
                        if (query[i].operator != null) {
                            vm.warning.query += " " + query[i].operator.toUpperCase() + " ";
                        }
                    }
                    return true;
                } else {
                    AlertService.error(error);
                    return false;
                }
            } else {
                return true;
            }
        }

        function getSavedActionArguments() {
            if (vm.warning != null && vm.warning.greengrassArguments != null) {
                return angular.copy(vm.warning.greengrassArguments) || {};
            }

            if (vm.warning == null || vm.warning.actionArguments == null || vm.warning.actionArguments === '') {
                return {};
            }

            try {
                return angular.fromJson(vm.warning.actionArguments) || {};
            } catch (e) {
                return {};
            }
        }
        function hasStoredGreengrassCommand() {
            if (vm.warning == null) {
                return false;
            }

            if (vm.warning.greengrassCommandName != null && vm.warning.greengrassCommandName !== '') {
                return true;
            }

            if (vm.warning.actionArguments == null || vm.warning.actionArguments === '') {
                return false;
            }

            try {
                var args = angular.fromJson(vm.warning.actionArguments);
                return args != null && args[vm.GREENGRASS_COMMAND_KEY] != null && args[vm.GREENGRASS_COMMAND_KEY] !== '';
            } catch (e) {
                return false;
            }
        }

        function parseArgumentSchema(argumentsSchema) {
            if (argumentsSchema == null || argumentsSchema === '') return null;
            if (angular.isObject(argumentsSchema)) return argumentsSchema;
            try {
                return angular.fromJson(argumentsSchema);
            } catch (e) {
                return null;
            }
        }

        function getManifestArgumentType(argument) {
            var type = argument != null && argument.type != null ? ('' + argument.type).toLowerCase() : '';
            if (type === 'toggle') return 'boolean';
            if (type === 'slider') return 'number';
            if (type === 'input') {
                if (argument.defaultValue != null && typeof argument.defaultValue === 'number') return 'number';
                if (argument.props != null && (argument.props.min != null || argument.props.max != null)) return 'number';
                return 'string';
            }
            if (type === 'select') return argument.defaultValue != null && typeof argument.defaultValue === 'number' ? 'number' : 'string';
            if (type === 'timepicker' || type === 'datepicker') return 'string';
            return type || 'string';
        }

        function buildArgumentsSchemaFromManifestArguments(argumentsList) {
            if (!angular.isArray(argumentsList) || argumentsList.length === 0) return null;

            var schema = { type: 'object', properties: {} };

            argumentsList.forEach(function (argument, index) {
                if (argument == null || argument.key == null || argument.key === '') return;

                var props = argument.props || {};
                var property = {};

                property.type = getManifestArgumentType(argument);
                property.component = argument.type;
                property.defaultValue = argument.defaultValue;
                property.description = props.description || props.label || '';
                property.title = props.label || props.title || argument.key;
                property.order = index + 1;

                if (argument.defaultValue !== undefined && argument.defaultValue !== null) {
                    property.default = argument.defaultValue;
                }

                // timepicker
                if (argument.type === 'timepicker') {
                    property.format = 'time';
                }

                // slider/range
                if (argument.type === 'slider') {
                    property.component = 'range';
                    property.options = {
                        step: 1,
                        floor: props.min !== undefined ? props.min : 0,
                        ceil: props.max !== undefined ? props.max : 100
                    };
                    property.minimum = props.min;
                    property.maximum = props.max;
                    if (props.thumbLabel !== undefined) property.thumbLabel = props.thumbLabel;
                }

                // select — converti label → name come fa ActionCommandsController
                if (argument.type === 'select' && props.options && props.options.length > 0) {
                    property.titleMap = props.options.map(function (option) {
                        return {
                            name: option.label || option.name || String(option.value),
                            value: String(option.value)
                        };
                    });
                    property.enum = props.options.map(function (option) {
                        return String(option.value);
                    });
                    if (property.default !== undefined && property.default !== null) {
                        property.default = String(property.default);
                    }
                }

                if (props.required) {
                    if (!schema.required) schema.required = [];
                    schema.required.push(argument.key);
                }

                if (props.min != null) property.minimum = props.min;
                if (props.max != null) property.maximum = props.max;

                schema.properties[argument.key] = property;
            });

            return Object.keys(schema.properties).length > 0 ? schema : null;
        }

        function isInvalidArgumentValue(value) {
            return value === null || value === undefined || value === '' || value !== value || value === 'NaN';
        }

        function isNumericArgument(property) {
            return property != null && (
                property.type === 'number' ||
                property.type === 'integer' ||
                property.component === 'slider' ||
                property.component === 'range' ||
                property.component === 'number'
            );
        }

        function isBooleanArgument(property) {
            return property != null && (
                property.type === 'boolean' ||
                property.component === 'checkbox' ||
                property.component === 'toggle'
            );
        }

        function getDefaultArgumentValue(property) {
            if (property == null) return '';
            if (property.hasOwnProperty('default')) return property.default;
            if (property.hasOwnProperty('defaultValue')) return property.defaultValue;
            if (isNumericArgument(property)) return 0;
            if (isBooleanArgument(property)) return false;
            if (property.type === 'array') return [];
            if (property.type === 'object') return {};
            return '';
        }

        function normalizeArgumentValue(value, property) {
            if (isInvalidArgumentValue(value)) {
                value = getDefaultArgumentValue(property);
            }
            if (isNumericArgument(property)) {
                var numericValue = Number(value);
                return isNaN(numericValue) ? Number(getDefaultArgumentValue(property)) : numericValue;
            }
            // Converti stringa "HH:mm" → Date per timepicker
            if (property != null && property.component === 'timepicker' && typeof value === 'string' && value.indexOf(':') !== -1) {
                var timeParts = value.split(':');
                var timeDate = new Date();
                timeDate.setHours(parseInt(timeParts[0]) || 0);
                timeDate.setMinutes(parseInt(timeParts[1]) || 0);
                timeDate.setSeconds(0);
                timeDate.setMilliseconds(0);
                return timeDate;
            }
            return value;
        }

        // Restituisce un oggetto contenente gli argomenti e relativi valori per il comando selezionato
        function buildCompleteActionArguments() {
            var args = {};
            var previousArgs = getSavedActionArguments();
            var action = vm.warning != null ? vm.warning.action : null;
            var schema = action != null ? parseArgumentSchema(action.argumentsSchema) : null;

            if(schema == null && vm.formSchemas != null && vm.formSchemas.schema != null) {
                schema = vm.formSchemas.schema;
            }

            // Nessuno schema > nessun argomento
            if(schema == null || schema.properties == null) {
                return {};
            }

            Object.keys(schema.properties).forEach(function (arg) {
                var value = vm.formSchemas != null ? vm.formSchemas[arg] : null;

                if(isInvalidArgumentValue(value) && previousArgs.hasOwnProperty(arg)) {
                    value = previousArgs[arg];
                }

                value = normalizeArgumentValue(value, schema.properties[arg]);

                // Converti Date → "HH:mm" per timepicker prima del salvataggio
                if (schema.properties[arg] != null &&
                    schema.properties[arg].component === 'timepicker' &&
                    value instanceof Date) {
                    value = padTime(value.getHours()) + ":" + padTime(value.getMinutes());
                }

                args[arg] = value;
            });

            return args;
        }

        vm.save = function (createQ) {
            if(createQ){
                vm.isSaving = true;
                vm.warning.active = false;
                vm.warning.composed = vm.compose;

                var selectedNoAction = vm.warning.action != null && vm.warning.action.id == -1;
                var selectedNoMacro = vm.warning.macro != null && vm.warning.macro.id == -1;

                if (selectedNoAction) {
                    vm.warning.action = null;
                }

                if (selectedNoMacro) {
                    vm.warning.macro = null;
                }

                var hasSelectedAction = vm.warning.action != null;
                var hasSelectedMacro = vm.warning.macro != null;

                if (vm.isGreengrassObjectType && hasSelectedAction && vm.warning.action.manifestCommand === true) {
                    var greengrassArgs = buildCompleteActionArguments();

                    greengrassArgs[vm.GREENGRASS_COMMAND_KEY] = vm.warning.action.actionCommand;
                    greengrassArgs[vm.GREENGRASS_TARGET_KEY] = vm.warning.action.componentName;

                    vm.warning.actionArguments = angular.toJson(greengrassArgs);
                    vm.warning.action = null;
                    vm.warning.macro = null;
                } else if (hasSelectedAction) {
                    vm.warning.actionArguments = angular.toJson(buildCompleteActionArguments());
                } else if (hasSelectedMacro) {
                    vm.formSchemas = null;
                    vm.warning.actionArguments = null;
                    vm.warning.action = null;
                } else if (vm.isGreengrassObjectType && hasStoredGreengrassCommand()) {
                    var storedGreengrassArgs = getSavedActionArguments();

                    if (vm.warning.greengrassCommandName != null && vm.warning.greengrassCommandName !== '') {
                        storedGreengrassArgs[vm.GREENGRASS_COMMAND_KEY] = vm.warning.greengrassCommandName;
                    }

                    if (vm.warning.greengrassTarget != null && vm.warning.greengrassTarget !== '') {
                        storedGreengrassArgs[vm.GREENGRASS_TARGET_KEY] = vm.warning.greengrassTarget;
                    }

                    vm.warning.actionArguments = angular.toJson(storedGreengrassArgs);
                    vm.warning.action = null;
                    vm.warning.macro = null;
                } else {
                    vm.formSchemas = null;
                    vm.warning.actionArguments = null;
                    vm.warning.action = null;
                    vm.warning.macro = null;
                }

                if (vm.warning.id !== null) {
                    Warning.update(vm.warning, onSaveSuccess, onSaveError);
                } else {
                    if (angular.isArray(vm.warning.tabFleets)) {
                        vm.fleetsTosave = angular.copy(vm.warning.tabFleets);
                    } else if (vm.warning.tabFleets != null && vm.warning.tabFleets.id != null) {
                        vm.fleetsTosave = [angular.copy(vm.warning.tabFleets)];
                    } else {
                        vm.fleetsTosave = [];
                    }

                    if (vm.fleetsTosave.length === 0) {
                        AlertService.error("Fleet is required");
                        vm.isSaving = false;
                        return;
                    }

                    vm.warning.composed = vm.compose;
                    vm.isSaving = true;
                    vm.saveByFleet();
                }
            }
        };

        function padTime(value) {
            value = parseInt(value, 10);
            if (isNaN(value)) {
                value = 0;
            }
            return value < 10 ? '0' + value : '' + value;
        }

        vm.saveByFleet = function () {
            if (vm.fleetsTosave == null || vm.fleetsTosave.length === 0) {
                AlertService.error("Fleet is required");
                vm.isSaving = false;
                return;
            }

            vm.warning.tabFleets = angular.copy(vm.fleetsTosave[0]);
            vm.fleetsTosave.splice(0, 1);

            Warning.save(vm.warning, onSaveSuccess, onSaveError);
        };


        vm.loadAll = function (resourceService, resource, resourcePage, headerLink) {
            var query = {
                page: resourcePage,
                query: vm.typeToSearch != undefined && vm.typeToSearch != "" ? vm.typeToSearch : "",
                size: 20
            };

            resourceService.query(query, onSuccess, onError);

            function onSuccess(data, headers) {
                var links = ParseLinks.parse(headers('link'));
                for (var key in links) headerLink[key] = links[key];
                for (var i = 0; i < data.length; i++) resource.push(data[i]);
            }

            function onError(error) {

                AlertService.error(error.data.message);
            }
        };

        vm.loadObjectTypePage = function (page) {
            if (page <= vm.objectTypeLinks['last']) {
                vm.objectTypePage = page;
                vm.loadAll(TabObjectTypes, vm.tabObjectTypes, vm.objectTypePage, vm.objectTypeLinks);
            }
        };

        vm.loadFleetPage = function (page) {
            if (page <= vm.fleetLinks['last']) {
                vm.fleetPage = page;
                vm.loadAll(TabFleets, vm.tabFleets, vm.fleetPage, vm.fleetLinks);
            }
        };

        vm.loadWarningCategoryPage = function (page) {
            if (page <= vm.warningCategoryLinks['last']) {
                vm.warningCategoryPage = page;
                vm.loadAll(WarningCategory, vm.warningCategories, vm.warningCategoryPage, vm.warningCategoryLinks);
            }
        };

        vm.loadUserProfilePage = function (page) {
            if (page <= vm.userProfileLinks['last']) {
                vm.userProfilePage = page;
                vm.loadAll(UserProfile, vm.userProfiles, vm.userProfilePage, vm.userProfileLinks);
            }
        };

        vm.search = function (searchText) {
            vm.typeToSearch = searchText;
            vm.tabObjectTypes = [];
            vm.objectTypePage = 0;
            vm.loadAll(TabObjectTypes, vm.tabObjectTypes, vm.objectTypePage, vm.objectTypeLinks);
        };
        vm.loadAll(TabObjectTypes, vm.tabObjectTypes, vm.objectTypePage, vm.objectTypeLinks);
        vm.loadAll(TabFleets, vm.tabFleets, vm.fleetPage, vm.fleetLinks);
        vm.loadAll(WarningCategory, vm.warningCategories, vm.warningCategoryPage, vm.warningCategoryLinks);
        vm.loadAll(UserProfile, vm.userProfiles, vm.userProfilePage, vm.userProfileLinks);

        function clearRuleResponses(clearSelectedResponse) {
            vm.commandList = [];
            vm.macro = [];
            vm.formSchemas = null;

            if(clearSelectedResponse === true) {
                vm.warning.action = null;
                vm.warning.macro = null;
            }
        }

        function hasSelectedObjectType() {
            return vm.warning != null && vm.warning.tabObjectTypes != null && vm.warning.tabObjectTypes.id != null;
        }

        vm.canLoadRuleResponses = function () {
            return hasSelectedObjectType() && vm.getSelectedFleetId() != null;
        };

        vm.onObjectTypeChange = function () {
            vm.refreshIndex();
            clearRuleResponses(true);
            vm.getActions();
        };

        vm.onFleetChange = function () {
            clearRuleResponses(true);
            vm.getActions();
        };

        vm.loadRuleResponsesIfAvailable = function () {
            if (vm.canLoadRuleResponses()) {
                vm.getActions();
            } else {
                clearRuleResponses(false);
            }
        };

        vm.getActions = function () {
            if (!vm.canLoadRuleResponses()) {
                clearRuleResponses(false);
                return;
            }

            var noAction = { id: -1, actionCommand: "No Command" };
            var noMacro = { id: -1, alias: "No Macro" };

            vm.commandList = [];
            vm.macro = [];

            var fleetId = vm.getSelectedFleetId();

            vm.checkIfObjectTypeIsGreengrass(function () {
                if (vm.isGreengrassObjectType) {
                    vm.loadGreengrassActions(noAction, noMacro);
                } else {
                    Macro.byObjectType({ id: vm.warning.tabObjectTypes.id, fleet: fleetId, page: 0, size: 1000 }, onSuccessMacro);
                    TabActions.actionsByObjectType({ id: vm.warning.tabObjectTypes.id }, onSuccess);
                }
            });

            function onSuccess(actions) {
                vm.commandList = actions || [];
                if (vm.warning.action != null) vm.checkArguments();
                vm.commandList.push(noAction);
            }

            function onSuccessMacro(data) {
                vm.macro.length = 0;
                for (var i = 0; i < data.length; i++) vm.macro.push(data[i]);
                vm.macro.push(noMacro);
            }
        };

        vm.checkIfObjectTypeIsGreengrass = function (callback) {
            if (!vm.warning.tabObjectTypes || !vm.warning.tabObjectTypes.id) {
                vm.isGreengrassObjectType = false;
                if (callback) callback();
                return;
            }
            if (vm.warning.tabObjectTypes.greengrassType === true || vm.warning.tabObjectTypes.greengrassType === false) {
                vm.isGreengrassObjectType = vm.warning.tabObjectTypes.greengrassType === true;
                if (callback) callback();
                return;
            }
            if (vm.objectTypeCache[vm.warning.tabObjectTypes.id]) {
                vm.isGreengrassObjectType = vm.objectTypeCache[vm.warning.tabObjectTypes.id].greengrassType === true;
                if (callback) callback();
                return;
            }
            $http.get('api/tab-object-types/' + vm.warning.tabObjectTypes.id)
                .then(function (response) {
                    vm.objectTypeCache[vm.warning.tabObjectTypes.id] = response.data;
                    vm.warning.tabObjectTypes.greengrassType = response.data.greengrassType;
                    vm.isGreengrassObjectType = response.data.greengrassType === true;
                    if (callback) callback();
                })
                .catch(function () {
                    vm.isGreengrassObjectType = false;
                    if (callback) callback();
                });
        };

        vm.getSelectedFleetId = function () {
            if (vm.warning == null || vm.warning.tabFleets == null) return null;
            var fleetId = angular.isArray(vm.warning.tabFleets) ?
                (vm.warning.tabFleets.length > 0 && vm.warning.tabFleets[0] != null ? vm.warning.tabFleets[0].id : null) :
                (vm.warning.tabFleets.id != null ? vm.warning.tabFleets.id : null);
            return (fleetId == null || Number(fleetId) < 1) ? null : fleetId;
        };

        vm.filterResponseCommand = function (search) {
            return function (item) {
                if (item == null) {
                    return false;
                }

                if (search == null || search === '') {
                    return true;
                }

                var text = search.toLowerCase();

                var commandName = item.actionCommand != null ? item.actionCommand.toLowerCase() : '';
                var componentName = item.componentName != null ? item.componentName.toLowerCase() : '';
                var description = item.description != null ? item.description.toLowerCase() : '';

                return commandName.indexOf(text) !== -1 ||
                    componentName.indexOf(text) !== -1 ||
                    description.indexOf(text) !== -1;
            };
        };

        vm.loadGreengrassActions = function (noAction, noMacro) {
            var fleetId = vm.getSelectedFleetId();

            vm.commandList = [noAction];
            vm.macro.length = 0;
            vm.macro.push(noMacro);

            if (vm.warning.tabObjectTypes == null || vm.warning.tabObjectTypes.id == null || fleetId == null) return;

            Macro.queryGreengrassByObjectType({
                objectTypeId: vm.warning.tabObjectTypes.id,
                fleetId: fleetId,
                page: 0,
                size: 1000
            }, function (data) {
                vm.macro.length = 0;
                for (var i = 0; i < data.length; i++) vm.macro.push(data[i]);
                vm.macro.push(noMacro);
            }, function () {
                vm.macro.length = 0;
                vm.macro.push(noMacro);
            });

            $http.get('api/tab-objects/with-manifest', { params: { fleetId: fleetId, typeId: vm.warning.tabObjectTypes.id } })
                .then(function (response) {
                    return CommandManifest.get({ objectUniqueCode: response.data.objectUniqueCode }).$promise;
                })
                .then(function (manifestData) {
                    vm.processManifestTemplate(manifestData, noAction);
                })
                .catch(function (error) {
                    vm.commandList = [noAction];
                    // if (error.status === 404) {
                    //    AlertService.error('No Greengrass manifest available for the selected object type and fleet.');
                    // } else {
                    //    AlertService.error('Error loading commands from manifest');
                    // }
                });
        };

        vm.processManifestTemplate = function (manifestData, noAction) {
            vm.commandList = [];

            if (!manifestData || !manifestData.manifest) {
                vm.commandList.push(noAction);
                return;
            }

            var manifest = manifestData.manifest.manifest ? manifestData.manifest.manifest : manifestData.manifest;
            var commandIndex = 0;

            angular.forEach(manifest, function (commands, componentName) {
                angular.forEach(commands, function (command) {
                    if (command.command_name) {
                        vm.commandList.push({
                            id: 'manifest_' + commandIndex,
                            actionCommand: command.command_name,
                            description: command.description || command.command_name,
                            componentName: command.component || componentName,
                            manifestCommand: true,
                            argumentsSchema: command.argumentsSchema || command.arguments_schema || command.schema || buildArgumentsSchemaFromManifestArguments(command.arguments),
                            weight: command.weight || 1,
                            permissionLevel: command.permission_level || command.permissionLevel || 0
                        });
                        commandIndex++;
                    }
                });
            });

            vm.restoreGreengrassCommandSelection();
            vm.commandList.push(noAction);
        };

        vm.restoreGreengrassCommandSelection = function () {
            var commandName = vm.getGreengrassCommandName();
            var target = vm.getGreengrassTarget();
            if (commandName == null) return;
            for (var i = 0; i < vm.commandList.length; i++) {
                if (vm.commandList[i].actionCommand === commandName && (target == null || vm.commandList[i].componentName === target)) {
                    vm.warning.action = vm.commandList[i];
                    vm.checkArguments();
                    return;
                }
            }
        };

        vm.getGreengrassCommandName = function () {
            if (vm.warning != null && vm.warning.greengrassCommandName != null && vm.warning.greengrassCommandName !== '') {
                return vm.warning.greengrassCommandName;
            }

            if (vm.warning == null || vm.warning.actionArguments == null) {
                return null;
            }

            try {
                return angular.fromJson(vm.warning.actionArguments)[vm.GREENGRASS_COMMAND_KEY];
            } catch (e) {
                return null;
            }
        };

        vm.getGreengrassTarget = function () {
            if (vm.warning != null && vm.warning.greengrassTarget != null && vm.warning.greengrassTarget !== '') {
                return vm.warning.greengrassTarget;
            }

            if (vm.warning == null || vm.warning.actionArguments == null) {
                return null;
            }

            try {
                return angular.fromJson(vm.warning.actionArguments)[vm.GREENGRASS_TARGET_KEY];
            } catch (e) {
                return null;
            }
        };

        vm.onMacroChange = function () {
            if (vm.warning.macro != null && vm.warning.macro.id != null && vm.warning.macro.id != -1) {
                vm.warning.action = null;
                vm.formSchemas = null;
            }
        };

        if (vm.warning.$promise) {
            vm.warning.$promise.then(function () {
                if (vm.warning.id === null && vm.warning.cloned !== true) {
                    vm.compose = true;
                    vm.isGreengrassObjectType = false;
                    clearRuleResponses(false);
                } else {
                    vm.compose = vm.warning.composed;
                }

                vm.loadMetric();
            });
        }

        function findType(name) {
            name = name.replace(/\s/g, '');
            var obj = $filter('filter')(vm.metric, { name: name });
            for (var i = 0; i < obj.length; i++) {
                if (obj[i].name === name) return obj[i].type;
            }
        }

        function getEditQuery() {
            vm.originalQuery = vm.warning.query;
            localStorage.setItem("originalQuery", JSON.stringify(vm.originalQuery));
            if (vm.warning.composed) {
                vm.lastQuery = vm.warning.query;
                var modifiedQuery = vm.warning.query.replace(/"/g, '');
                modifiedQuery = modifiedQuery.replace(/\!\(!/g, "!");
                if (modifiedQuery.endsWith(")")) modifiedQuery = modifiedQuery.slice(0, -1);
                vm.modifiedQuery = modifiedQuery;
                var op = modifiedQuery.split(" ");
                vm.operator = [];
                for (var i = 0; i < op.length; i++) {
                    if (op[i] === "AND") vm.operator.push({ name: "AND" });
                    if (op[i] === "OR") vm.operator.push({ name: "OR" });
                }
                var query = modifiedQuery.split("AND");
                var subQuery = [];
                for (var i = 0; i < query.length; i++) {
                    var app = query[i].split("OR");
                    for (var j = 0; j < app.length; j++) subQuery.push(app[j]);
                }
                query = subQuery;
                subQuery = [];
                for (var i = 0; i < query.length; i++) {
                    var app = query[i].split(":");
                    for (var j = 0; j < app.length; j++) subQuery.push(app[j]);
                }
                vm.quantity = vm.operator.length + 1;
                vm.tempMetric = [];
                for (var i = 0; i < query.length; i++) {
                    var app = {};
                    if (subQuery[i * 2] === "_exists_" || subQuery[i * 2] === "!_exists_" ||
                        subQuery[i * 2] === " _exists_" || subQuery[i * 2] === " !_exists_") {
                        if (subQuery[i * 2] === "_exists_" || subQuery[i * 2] === " _exists_") {
                            app.name = subQuery[(i * 2) + 1];
                            app.type = findType(app.name);
                            vm.tempMetric.push(app);
                            vm.checkType.push("Exists");
                        } else {
                            app.name = subQuery[(i * 2) + 1];
                            app.type = findType(app.name);
                            vm.tempMetric.push(app);
                            vm.checkType.push("Not Exists");
                        }
                        pushExistsNullMetric();
                    } else {
                        var equals = true;
                        switch (subQuery[(i * 2) + 1].charAt(0)) {
                            case "<":
                                if (subQuery[(i * 2) + 1].charAt(1) === "=") {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    var v = subQuery[(i * 2) + 1].replace(/\s/g, '');
                                    var value = v.replace('<', '').replace('=', '');
                                    if (app.type === "date") {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Lower equals");
                                        if (value.charAt(0) === "n") {
                                            for (var i = 0; i < vm.tempMetric.length - 1; i++) pushRelativeDate();
                                            relativeDate(value);
                                        } else {
                                            removeChar('<', true, subQuery[(i * 2) + 1]);
                                        }
                                    } else {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Lower equals");
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                        }
                                        vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                    }
                                    equals = false;
                                } else {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    var value = subQuery[(i * 2) + 1].replace(/\s/g, '').replace('<', '');
                                    if (app.type === "date") {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Lower");
                                        if (value.charAt(0) === "n") {
                                            for (var i = 0; i < vm.tempMetric.length - 1; i++) pushRelativeDate();
                                            relativeDate(value);
                                        } else {
                                            removeChar('<', false, subQuery[(i * 2) + 1]);
                                        }
                                    } else {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Lower");
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                        }
                                        vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                    }
                                    equals = false;
                                }
                                break;
                            case ">":
                                if (subQuery[(i * 2) + 1].charAt(1) === "=") {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    var v = subQuery[(i * 2) + 1].replace(/\s/g, '');
                                    var value = v.replace('>', '').replace('=', '');
                                    if (app.type === "date") {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Greater equals");
                                        if (value.charAt(0) === "n") {
                                            for (var i = 0; i < vm.tempMetric.length - 1; i++) pushRelativeDate();
                                            relativeDate(value);
                                        } else {
                                            removeChar('>', true, subQuery[(i * 2) + 1]);
                                        }
                                    } else {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Greater equals");
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                        }
                                        vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                    }
                                    equals = false;
                                } else {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    var v = subQuery[(i * 2) + 1].replace(/\s/g, '');
                                    var value = v.replace('>', '');
                                    if (app.type === "date") {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Greater");
                                        if (value.charAt(0) === "n") {
                                            for (var i = 0; i < vm.tempMetric.length - 1; i++) pushRelativeDate();
                                            relativeDate(value);
                                        } else {
                                            removeChar('>', false, subQuery[(i * 2) + 1]);
                                        }
                                    } else {
                                        vm.tempMetric.push(app);
                                        vm.checkType.push("Greater");
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                        }
                                        vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                    }
                                    equals = false;
                                }
                                break;
                            case "[":
                                var subQueryD = query[i].split(":");
                                var subQueryDate = "";
                                for (var j = 1; j < subQueryD.length; j++) subQueryDate += subQueryD[j];
                                app.name = subQueryD[0];
                                app.type = findType(app.name);
                                if (app.type === "date") {
                                    vm.tempMetric.push(app);
                                    vm.checkType.push("Between");
                                    subQueryD = subQueryDate.split("TO");
                                    if (subQueryD[0].charAt(1) === "n") {
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.relativeDate.length != (vm.tempMetric.length - 1)) {
                                                vm.relativeDate.push(null); vm.relativeDateB.push(null);
                                                vm.relativeDateNumber.push(null); vm.relativeDateNumberB.push(null);
                                                vm.relativeDateSimbol.push(null); vm.relativeDateSimbolB.push(null);
                                            }
                                            if (vm.formDate.length != (vm.tempMetric.length - 1)) {
                                                vm.formDate.push(null); vm.typeDateForm.push(null);
                                            }
                                        }
                                        var relativeA = subQueryD[0].replace(/\s/g, '').replace('[', '');
                                        var relativeB = subQueryD[1].replace(/\s/g, '').replace(']', '');
                                        relativeA.length == 3 ? pushRelativeDateValue(null, null, null, null) :
                                            pushRelativeDateValue(relativeA.charAt(relativeA.length - 1), parseInt(relativeA.substring(4, relativeA.length - 1)), relativeA.charAt(3), relativeA);
                                        relativeB.length == 3 ? pushRelativeDateValueB(null, null, null, null) :
                                            pushRelativeDateValueB(relativeB.charAt(relativeB.length - 1), parseInt(relativeB.substring(4, relativeB.length - 1)), relativeB.charAt(3), relativeB);
                                        vm.formDate.push(false);
                                        vm.typeDateForm.push("relative");
                                    } else {
                                        for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                            if (vm.expectedDateA.length != (vm.tempMetric.length - 1)) {
                                                vm.expectedDateA.push(null); vm.expectedDateB.push(null);
                                            }
                                            if (vm.formDate.length != (vm.tempMetric.length - 1)) {
                                                vm.formDate.push(null); vm.typeDateForm.push(null);
                                            }
                                        }
                                        var dateA = subQueryD[0].replace('"', '').replace(/\s/g, '').replace('[', '');
                                        var dateB = subQueryD[1].replace('"', '').replace(/\s/g, '').replace(']', '');
                                        vm.expectedDateA.push(new Date(dateA));
                                        vm.expectedDateB.push(new Date(dateB));
                                        vm.expected.push(null); vm.expectedB.push(null);
                                        vm.formDate.push(false); vm.typeDateForm.push("absolute");
                                    }
                                } else {
                                    app.name = subQuery[(i * 2)];
                                    app.type = findType(app.name);
                                    vm.tempMetric.push(app);
                                    vm.checkType.push("Between");
                                    var v = subQuery[(i * 2) + 1].split("TO");
                                    v[0] = v[0].replace(/\s/g, '').replace('[', '');
                                    v[1] = v[1].replace(/\s/g, '').replace(']', '');
                                    for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                        if (vm.expectedA.length != (vm.tempMetric.length - 1)) vm.expectedA.push(null);
                                    }
                                    if (app.type === "float") {
                                        vm.expectedA.push(parseFloat(v[0]));
                                        vm.expectedB.splice(vm.expectedA.length - 1, 1, parseFloat(v[1]));
                                    } else {
                                        vm.expectedA.push(parseInt(v[0]));
                                        vm.expectedB.splice(vm.expectedA.length - 1, 1, parseInt(v[1]));
                                    }
                                }
                                equals = false;
                                break;
                        }
                        if (equals) {
                            app.name = subQuery[(i * 2)].replace(/\s/g, '');
                            vm.checkType.push(app.name.charAt(0) === "!" ? "Not Equals" : "Equals");
                            app.name = subQuery[(i * 2)].replace('!', '');
                            app.type = findType(app.name);
                            vm.tempMetric.push(app);
                            if (findType(app.name) === "date") {
                                var date = subQuery[(i * 2) + 1].replace(/\s/g, '').replace('>', '');
                                date = date.substring(1, date.length - 1);
                                for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                    if (vm.expectedDate.length != (vm.tempMetric.length - 1)) vm.expectedDate.push(null);
                                }
                                vm.expectedDate.push(new Date(date));
                                vm.formDate.push(false); vm.typeDateForm.push("absolute");
                            } else {
                                var value = subQuery[(i * 2) + 1].replace(/\s/g, '');
                                if (/^-?[\d.]+(?:e-?\d+)?$/.test(value)) {
                                    for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                        if (vm.expectedNumber.length != (vm.tempMetric.length - 1)) vm.expectedNumber.push(null);
                                    }
                                    vm.expectedNumber.push(app.type === "float" ? parseFloat(value) : parseInt(value));
                                } else {
                                    var str = subQuery[(i * 2) + 1].replace(/\"/g, '').replace(/\s/g, '');
                                    for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                                        if (vm.expected.length != (vm.tempMetric.length - 1)) {
                                            vm.expected.push(null); vm.expectedB.push(null);
                                        }
                                    }
                                    vm.expected.push(str);
                                }
                            }
                            vm.expectedB.push(null);
                        }
                    }
                }
            }
        }

        function pushRelativeDateValueB(valueD, ValueDN, ValueDS, exp) {
            vm.relativeDateB.push(valueD); vm.relativeDateNumberB.push(ValueDN);
            vm.relativeDateSimbolB.push(ValueDS); vm.expectedB.push(exp);
        }

        function pushRelativeDateValue(valueD, ValueDN, ValueDS, exp) {
            vm.relativeDate.push(valueD); vm.relativeDateNumber.push(ValueDN);
            vm.relativeDateSimbol.push(ValueDS); vm.expected.push(exp);
        }

        function removeChar(charComp, isEquals, date) {
            date = date.replace(/\s/g, '');
            date = charComp === '>' ? date.replace('>', '') : date.replace('<', '');
            if (isEquals) date = date.replace('=', '');
            date = date.substring(1, date.length - 1);
            for (var i = 0; i < vm.tempMetric.length - 1; i++) {
                if (vm.expectedDate.length != (vm.tempMetric.length - 1)) vm.expectedDate.push(null);
            }
            vm.expectedDate.push(new Date(date));
            vm.formDate.push(false); vm.typeDateForm.push("absolute");
        }

        function pushRelativeDate() {
            if (vm.relativeDate.length != (vm.tempMetric.length - 1)) {
                vm.relativeDate.push(null); vm.relativeDateNumber.push(null); vm.relativeDateSimbol.push(null);
                vm.relativeDateB.push(null); vm.relativeDateNumberB.push(null); vm.relativeDateSimbolB.push(null);
            }
            if (vm.formDate.length != (vm.tempMetric.length - 1)) {
                vm.formDate.push(null); vm.typeDateForm.push(null);
            }
        }

        function relativeDate(value) {
            if (value.length == 3) {
                pushDateFromRelative(null, null, null, null, null, null, null, null);
            } else {
                pushDateFromRelative(value.charAt(value.length - 1), parseInt(value.substring(4, value.length - 1)), value.charAt(3), null, null, null, value, null);
            }
            vm.formDate.push(false); vm.typeDateForm.push("relative");
        }

        function pushDateFromRelative(relD, relDN, relDS, relDB, relDNB, relDSB, exp, expB) {
            vm.relativeDate.push(relD); vm.relativeDateNumber.push(relDN); vm.relativeDateSimbol.push(relDS);
            vm.relativeDateB.push(relDB); vm.relativeDateNumberB.push(relDNB); vm.relativeDateSimbolB.push(relDSB);
            vm.expected.push(exp); vm.expectedB.push(expB);
        }

        function pushExistsNullMetric() {
            vm.expected.push(null); vm.expectedNumber.push(null); vm.expectedA.push(null); vm.expectedB.push(null);
            vm.expectedDate.push(null); vm.expectedDateA.push(null); vm.expectedDateB.push(null);
            vm.relativeDate.push(null); vm.relativeDateB.push(null); vm.relativeDateSimbol.push(null);
            vm.relativeDateSimbolB.push(null); vm.relativeDateNumber.push(null); vm.relativeDateNumberB.push(null);
        }

        vm.checkArguments = function () {
            if (vm.warning.action == null || vm.warning.action.id == null || vm.warning.action.id == -1) {
                $scope.formSchema = [];
                vm.formSchemas = null;
                return;
            }

            if (vm.warning.action != null && vm.warning.action.id != null && vm.warning.action.argumentsSchema != null) {
                $scope.formSchema = [];
                var data = vm.warning.action;
                var jArg = parseArgumentSchema(data.argumentsSchema);

                if (jArg == null || jArg.properties == null || Object.keys(jArg.properties).length === 0) {
                    vm.formSchemas = null;
                    return;
                }

                var first = Object.keys(jArg.properties)[0];
                if (jArg.properties[first].hasOwnProperty('order')) {
                    var orderProps = [];
                    orderProps.length = Object.keys(jArg.properties).length;
                    Object.keys(jArg.properties).forEach(function (val) {
                        orderProps.splice(Number(jArg.properties[val].order) - 1, 1, vm.getEntry(jArg, val, null));
                    });
                    orderProps.forEach(function (val) { $scope.formSchema.push(val); });
                } else {
                    Object.keys(jArg.properties).forEach(function (val) {
                        $scope.formSchema.push(vm.getEntry(jArg, val, null));
                    });
                }

                vm.formSchemas = {
                    command: data.actionCommand,
                    form: $scope.formSchema,
                    schema: jArg,
                    deviceReleases: data.deviceReleases,
                    actionId: data.id,
                    weight: data.weight
                };

                var savedArgs = getSavedActionArguments();
                Object.keys(jArg.properties).forEach(function (arg) {
                    vm.formSchemas[arg] = normalizeArgumentValue(savedArgs[arg], jArg.properties[arg]);
                });
            }
        };

        vm.onMacroChange = function () {
            if (vm.warning.macro != null && vm.warning.macro.id != null && vm.warning.macro.id != -1) {
                vm.warning.action = null;
                vm.formSchemas = null;
                $scope.formSchema = [];
            }
        };

        vm.onCommandChange = function () {

            // Reset arguments
            vm.warning.actionArguments = null;
            vm.warning.greengrassArguments = null;
            vm.formSchemas = null;
            $scope.formSchema = [];

            if (vm.warning.action != null && vm.warning.action.id != null) {

                // Reset macro
                vm.warning.macro = null;

                // "No command" option selected
                if (vm.warning.action.id === -1) {

                    // Reset action
                    vm.warning.action = null;

                    // Reset greengrass command
                    vm.warning.greengrassCommandName = null;
                    vm.warning.greengrassTarget = null;

                    return;
                }
            }

            vm.checkArguments();
        };

        vm.getEntry = function (jArg, val, arrayName) {
            var entry = {};
            entry.key = arrayName != null ? arrayName + "[]." + val : val;

            var prop = jArg.properties[val];
            var hasTitleMap = prop.hasOwnProperty('titleMap') && Array.isArray(prop.titleMap) && prop.titleMap.length > 0;

            if (hasTitleMap) {
                entry.titleMap = prop.titleMap;
                entry.type = 'select';
                entry.title = prop.title || val;
                entry.description = prop.description || '';
                entry.schema = prop;
                if (jArg.required && jArg.required.indexOf(val) !== -1) entry.required = true;
                if (prop.hasOwnProperty("pending")) {
                    prop.titleMap.forEach(function (title) {
                        if (title.value === prop.pending) prop.pending = title.name;
                    });
                }
            }

            if (prop.type === 'string' && !hasTitleMap) {
                entry.type = prop.format === 'time' ? 'timepicker' : 'text';
                entry.title = prop.title || val;
                entry.description = prop.description || '';
                entry.schema = prop;
                if (jArg.required && jArg.required.indexOf(val) !== -1) entry.required = true;
            }

            if (prop.type === 'boolean') {
                entry.title = prop.title || val;
                entry.description = prop.description || '';
                entry.schema = prop;
                if (jArg.required && jArg.required.indexOf(val) !== -1) entry.required = true;
            }

            if (prop.hasOwnProperty('component') && !hasTitleMap) {
                entry.type = prop.component === 'toggle' ? 'checkbox' : prop.component;
            }

            if (prop.hasOwnProperty('options')) entry.options = prop.options;
            if (prop.hasOwnProperty('style')) entry.style = prop.style;
            if (prop.hasOwnProperty('maxDate')) entry.maxDate = prop.maxDate;
            if (prop.hasOwnProperty('minDate')) entry.minDate = prop.minDate;

            if (prop.hasOwnProperty('format') && prop.format === 'time') {
                if (prop.default && typeof prop.default === 'string') {
                    var timeParts = prop.default.split(':');
                    var timeDate = new Date();
                    timeDate.setHours(parseInt(timeParts[0]) || 0);
                    timeDate.setMinutes(parseInt(timeParts[1]) || 0);
                    timeDate.setSeconds(0);
                    timeDate.setMilliseconds(0);
                    prop.default = timeDate;
                }
            }

            if (prop.hasOwnProperty('default')) {
                prop.defaultRestore = angular.copy(prop.default);
            }

            var savedDefaults = getSavedActionArguments();

            if (savedDefaults != null && savedDefaults.hasOwnProperty(val)) {
                prop.default = normalizeArgumentValue(savedDefaults[val], prop);
            } else if (!prop.hasOwnProperty('default')) {
                prop.default = getDefaultArgumentValue(prop);
            }

            if (prop.hasOwnProperty('items')) {
                entry.items = [];
                var first = Object.keys(prop.items.properties)[0];
                if (prop.items.properties[first].hasOwnProperty('order')) {
                    var orderProps = [];
                    orderProps.length = Object.keys(prop.items.properties).length;
                    Object.keys(prop.items.properties).forEach(function (item) {
                        orderProps.splice(Number(prop.items.properties[item].order) - 1, 1, vm.getEntry(prop.items, item, val));
                    });
                    orderProps.forEach(function (val) { entry.items.push(val); });
                } else {
                    Object.keys(prop.items.properties).forEach(function (item) {
                        entry.items.push(vm.getEntry(prop.items, item, val));
                    });
                }
            }

            return entry;
        };

        vm.refreshIndex = function () {
            vm.warning.index = null;
            vm.tempMetric = [];
        };

        vm.loadMetric = function () {
            vm.addMetric = [{ name: "AND" }, { name: "OR" }];
            vm.checkTypes = ["Exists", "Not Exists", "Equals", "Not Equals"];
            vm.checkTypesNumeric = ["Exists", "Not Exists", "Equals", "Not Equals", "Lower", "Lower equals", "Greater", "Greater equals", "Between"];
            vm.metric = [];
            vm.tempMetric = [];

            if (vm.warning.index === "JoT") {
                TabObjectTypes.getMapping({ id: vm.warning.tabObjectTypes.id }, function (data) {
                    getPropMapping(data.properties);
                    retrieveQuery();
                }, function () {
                    // handled globally by interceptor
                });
            } else {
                var index = vm.warning.index === "TheTailKeepalive" ? { id: 0 } : { id: 1 };
                TabObjectTypes.getMappingByIndex(index, function (data) {
                    getPropMapping(data.properties);
                    retrieveQuery();
                }, function () {
                    // handled globally by interceptor
                });
            }

            function getPropMapping(obj) {
                angular.forEach(obj, function (value, key) {
                    if (value.type == undefined) {
                        angular.forEach(value.properties, function (value, key2) {
                            getProperties(value, key2, key);
                        });
                    } else {
                        vm.metric.push({ name: key, type: value.type });
                    }
                });
                for (var i = 0; i < vm.metric.length; i++) {
                    if (vm.metric[i].name === "date") { vm.metric.splice(i, 1); break; }
                }
            }

            function getProperties(value, key, metric) {
                var subMetric = "." + key.toString();
                if (value.type == undefined) {
                    angular.forEach(value.properties, function (value, key) {
                        getProperties(value, key, metric + subMetric);
                    });
                } else {
                    vm.metric.push({ name: metric + subMetric, type: value.type });
                }
            }

            vm.checkMetricType = function (index) {
                if (vm.tempMetric[index].type === "keyword" || vm.tempMetric[index].type === "boolean" || vm.tempMetric[index].type === "text") return true;
                vm.formDate[index] = vm.tempMetric[index].type === "date" && (vm.typeDateForm[index] === "" || vm.typeDateForm[index] == null);
                return false;
            };

            vm.changeDate = function (index) { vm.formDate[index] = false; };

            vm.changeDateRelative = function (index) {
                if (vm.relativeDateSimbol[index] == null) vm.relativeDateSimbol[index] = "+";
                if (vm.relativeDateNumber[index] == null) vm.relativeDateNumber[index] = 1;
                vm.expected[index] = "now" + vm.relativeDateSimbol[index] + vm.relativeDateNumber[index] + vm.relativeDate[index];
            };

            vm.changeDateRelativeB = function (index) {
                if (vm.relativeDateSimbolB[index] == null) vm.relativeDateSimbolB[index] = "+";
                if (vm.relativeDateNumberB[index] == null) vm.relativeDateNumberB[index] = 1;
                vm.expectedB[index] = "now" + vm.relativeDateSimbolB[index] + vm.relativeDateNumberB[index] + vm.relativeDateB[index];
            };

            vm.checkMetricDate = function (index) { return vm.tempMetric[index].type === "date"; };

            vm.openCalendar = function (e, index) {
                e.preventDefault(); e.stopPropagation();
                vm.metricDate[index] = vm.metricDate[index] ? { isOpen: !vm.metricDate[index].isOpen } : { isOpen: true };
            };

            vm.openDownCalendar = function (e, index) {
                e.preventDefault(); e.stopPropagation();
                vm.metricDateDown[index] = vm.metricDateDown[index] ? { isOpen: !vm.metricDateDown[index].isOpen } : { isOpen: true };
            };

            vm.clearOperator = function (index) {
                vm.operator[index] = null; vm.checkType[index] = null;
                vm.expected[index] = null; vm.expectedNumber[index] = null;
                vm.expectedA[index] = null; vm.expectedB[index] = null;
                vm.expectedDate[index] = null; vm.expectedDateA[index] = null; vm.expectedDateB[index] = null;
                vm.typeDateForm[index] = null; vm.formDate[index] = true;
                vm.relativeDateNumber[index] = null; vm.relativeDate[index] = null; vm.relativeDateSimbol[index] = null;
                vm.relativeDateNumberB[index] = null; vm.relativeDateB[index] = null; vm.relativeDateSimbolB[index] = null;
            };

            vm.addQuantity = function (index) {
                if (index == Object.keys(vm.tempMetric).length - 1) vm.quantity++;
            };
        };

        function retrieveQuery() {
            if (vm.warning.id != null || vm.warning.cloned === true) {
                getEditQuery();
                vm.loadRuleResponsesIfAvailable();
            }
        }

        vm.deleteMetric = function (index) {
            vm.expected.splice(index, 1); vm.expectedNumber.splice(index, 1);
            vm.expectedA.splice(index, 1); vm.expectedB.splice(index, 1);
            vm.expectedDate.splice(index, 1); vm.expectedDateA.splice(index, 1); vm.expectedDateB.splice(index, 1);
            vm.relativeDate.splice(index, 1); vm.relativeDateB.splice(index, 1);
            vm.relativeDateSimbol.splice(index, 1); vm.relativeDateSimbolB.splice(index, 1);
            vm.relativeDateNumber.splice(index, 1); vm.relativeDateNumberB.splice(index, 1);
            vm.checkType.splice(index, 1); vm.tempMetric.splice(index, 1);
            if (vm.tempMetric.length == 1) {
                vm.operator.splice(index - 1, 1);
            } else if (index == vm.tempMetric.length) {
                vm.operator.splice(index - 1, 2);
            } else {
                vm.operator.splice(index, 1);
            }
            vm.quantity--;
        };

        vm.editQuery = function () {
            if (createQuery()) {
                localStorage.setItem("edit-automatic-rule", JSON.stringify(vm.warning));
                $state.go('warning-edit-query');
            }
        };

        function updateNewQuery() {
            var lastQuery = JSON.parse(localStorage.getItem("originalQuery") || "null");
            var newQuery = vm.warning.query;
            if (lastQuery && newQuery && !newQuery.startsWith("!(") && !newQuery.endsWith(")") && /^!\(.*\)$/.test(lastQuery)) {
                vm.warning.query = "!(" + newQuery + ")";
            }
        }

        vm.checkSaveEdit = function () {
            var createQ = createQuery();
            if (createQ) {
                updateNewQuery();
                $uibModal.open({
                    templateUrl: 'app/entities/warning/check-save-edit.html',
                    controller: 'CheckSaveEditController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        query: function () {
                            return {
                                lastQuery: localStorage.getItem("originalQuery"),
                                newQuery: vm.warning.query
                            };
                        }
                    }
                }).result.then(function () {
                    vm.save(createQ);
                    localStorage.removeItem("originalQuery");
                });
            }
        };
        vm.clear = function () {
            $state.go('warning');
        };
    }
})();
